import type {
  AlgoliaProduct,
  AlgoliaProductImagesModel
} from '~/lib/AlgoliaService/models/AlgoliaProduct';
import type { GenerateImageOptions } from '~/utils/generateImageObject';
import { generateImageObject } from '~/utils/generateImageObject';

const DEFAULT_OPTIONS: GenerateImageOptions = {
  // XXX: might need to check if this fits most of the actual product images.
  originalWidth: 1000,
  originalHeight: 750,
  keepAspectRatio: true,
  fit: 'pad',
  bgColor: 'rgb:ffffff'
};

/**
 * Creates a product image from the given algolia product search result.
 *
 * @param product The product to use.
 * @param options The options to use. Merged with {@link DEFAULT_OPTIONS}.
 * @param logger The logger to use.
 */
export function createAlgoliaProductImage(
  product: AlgoliaProduct,
  options: GenerateImageOptions = {},
  logger = console
) {
  if (!product.product_image) {
    return;
  }

  try {
    const productImages: AlgoliaProductImagesModel = JSON.parse(
      product.product_image
    );
    const [firstProductImage] = Object.values(productImages)
      .filter((img) => img.medialink)
      .sort(
        (a, b) => Number(a.productimagesorting) - Number(b.productimagesorting)
      );
    const mergedOptions = Object.assign({}, DEFAULT_OPTIONS, options);

    return generateImageObject(firstProductImage?.medialink, mergedOptions);
  } catch (e) {
    logger.error(
      'createAlgoliaProductImage',
      'failed to parse algolia product images',
      e
    );
  }
}
